import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";

const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page7/Demo/Key1.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: {
      fontSize: 23,
      background: "none",
      borderBottom: "none",
      textAlign: "end",
    },
    inputSize: 60,
    textareaStyle: { width: 800, border: "2px solid black" },
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>Tra cứu</span>
        
        `,
      },
    ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>hướng dẫn</span>
        
        `,
      },
    ],
    titleQuestion: [
      {
        num: "",
        title: ` <img src="img/FriendsPlus/Page7/Demo/1.jpg" style="height:30mm;margin-left:-70px;margin-top:-30px "/> `,
        color: "rgb(3, 103, 181)",
        // star: 1
      },
    ],
    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='display:flex'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>1</b>
        	</div>
        		Quan sát thước đo rồi nêu số đo của mỗi góc (theo mẫu).
        </div>
        <div style='position:relative;'>
          <img src="img/FriendsPlus/Page7/Demo/2.jpg" style="height:17cm;margin-bottom:10px "/>
          <div style='position:absolute;top:50px;left:10px;width:4cm'>
            góc đỉnh O; cạnh OA, OB bằng 60°
          </div>
          <div style='position:absolute;top:50px;left:750px;width:4cm'>
            góc đỉnh O; cạnh OC, OD bằng <span style='width: 50px;padding:0px 0px;border:2px solid black;border-radius:10px'>#</span>
          </div>
          <div style='position:absolute;top:360px;left:200px;width:4cm'>
            góc đỉnh O; cạnh OE, OM bằng <span style='width: 50px;padding:0px 0px;border:2px solid black;border-radius:10px'>#</span>
          </div>
          <div style='position:absolute;top:360px;left:600px;width:4cm'>
            góc đỉnh O; cạnh ON, OP bằng <span style='width: 50px;padding:0px 0px;border:2px solid black;border-radius:10px'>#</span>
          </div>
          <div style='position:absolute;top:431px;left:716px;width:4cm'>
            °
          </div>
          <div style='position:absolute;top:431px;left:316px;width:4cm'>
            °
          </div>
          <div style='position:absolute;top:121px;left:866px;width:4cm'>
            °
          </div>
        </div>
        
            
            
            
        `,
        answer: ["90", "120", "180"],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page7/Demo/Key2.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: {
      fontSize: 23,
      background: "none",
      borderBottom: "none",
      textAlign: "end",
    },
    inputSize: 60,
    textareaStyle: { width: 800 },
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>Tra cứu</span>
        
        `,
      },
    ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>hướng dẫn</span>
        
        `,
      },
    ],
    titleQuestion: [
      {
        num: "",
        title: ` <img src="img/FriendsPlus/Page7/Demo/1.jpg" style="height:30mm;margin-left:-20px;margin-top:-30px "/> `,
        color: "rgb(3, 103, 181)",
        // star: 1
      },
    ],
    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='display:flex'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>2</b>
        	</div>
          Quan sát hình rồi nêu số đo các góc sau:
        </div>
        
        <img src="/img/FriendsPlus/Page7/Demo/3.jpg"  style="height:10cm;margin-left:70px" >
        <div style='position:relative'>
          <div style='display:flex;justify-content:space-around;line-height:60px'>
            <div>
              Góc đỉnh N; cạnh NM, NH bằng <span style='width: 50px;padding:0px 0px;border:2px solid black;border-radius:10px'>#</span><br>
              Góc đỉnh C; cạnh CA, CB bằng <span style='width: 50px;padding:0px 0px;border:2px solid black;border-radius:10px'>#</span><br>
            </div>
            <div>
              Góc đỉnh H; cạnh HM, HN bằng <span style='width: 50px;padding:0px 0px;border:2px solid black;border-radius:10px'>#</span><br>
              Góc đỉnh D; cạnh DA, DB bằng <span style='width: 50px;padding:0px 0px;border:2px solid black;border-radius:10px'>#</span><br>
            </div>
          </div>
          <div style='position:absolute;top:8px;left:453px;width:4cm'>
            °
          </div>
          <div style='position:absolute;top:8px;left:965px;width:4cm'>
            °
          </div>
          <div style='position:absolute;top:68px;left:955px;width:4cm'>
            °
          </div>
          <div style='position:absolute;top:68px;left:435px;width:4cm'>
            °
          </div>
        </div>
            
        `,
        answer: ["60", "120", "90", "60"],
      },
    ],
  },

  //   1: {
  //     unit: "Unit Starter",
  //     id: "FP8-WB-demo-2023-US-P7-E1",
  //     audio: "",
  //     video: "",
  //     exerciseKey: "/img/FriendsPlus/Page7/Key/E1answerKey.png",
  //     component: T6v2,
  //     inputSize: 130,
  //     maxLength: 1,
  //     stylesTextInput: {

  // 			// borderStyle: 'dashed',
  // 			borderWidth: 1,
  //       borderColor: 'black',
  //       width: 40,
  //       height: 40,
  //       justifyContent: 'center',
  //       alignItems: 'center',
  //     fontSize: '24px',
  //     textAlign: 'center',
  //     },

  //     titleQuestion: [
  //       {
  //         title: `<div style='display:flex'>
  //         <div style="background-color: rgb(61, 184, 187); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px;margin-top:-10px">
  //         1
  //     </div>        <div style='background:rgb(250,235,125);padding:5px 10px;border-radius:10px;width:120px;text-align: center; '>
  //         <span>> ; < ; =
  //         </spa
  //         </div>
  //         <div style='margin-left:5px;margin-top:5px'>
  //         ?
  //         </div>
  //         </div>
  //         </div>
  //         `
  //         ,
  //         color: "rgb(28, 192, 217)",
  //       },
  //     ],
  //     questionImage: [],
  //     isHiddenCheck: true,
  //     questions: [
  //       {
  //         title: `
  //        <div style='display:flex'>
  //        <div style='display:flex;line-height:2'>
  //        a)
  //        <div style='margin-left:10px;'>
  //        9 897&ensp; <input/>&ensp; 10 000 <br>
  //        68 534 <input/>&ensp;  68 499 <br>
  //        34 000 <input/>&ensp;  33 979
  //        </div>

  //        </div>
  //        <div style='margin-left:70px;display:flex;line-height:2'>
  //        b)
  //        <div style='margin-left:10px'>
  //        8 563&ensp; <input/>&ensp; 8 000 + 500 + 60 + 3 <br>
  //        45 031 <input/>&ensp;  40 000 + 5 000 + 100 + 30 <br>
  //        70 208 <input/>&ensp;  60 000 + 9 000 + 700 + 9       </div>

  //        </div>
  //        </div>
  //         `,
  //         answer: [
  //           `<`,`>`,`>`,`=`,`<`,`<`,

  //          ],
  //       },
  //     ],
  //   },
  //   2: {
  // 		unit: 'Starter',
  // 		id: 'SB7-S-P6-E4',
  // 		audio: '',
  // 		video: '',
  //     exerciseKey: "/img/FriendsPlus/Page7/Key/E2answerKey.png",
  // 		component: Circle_Write,

  // 		titleQuestion: [
  // 			{
  //         title: `<div style='display:flex'>
  //         <div style="background-color: rgb(61, 184, 187); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px;margin-top:-10px">
  //         2
  //     </div>        <div style='background:rgb(250,235,125);padding:5px 10px;border-radius:10px;text-align: center; '>
  //         <span>        Chọn câu trả lời đúng
  //         </span>
  //         </div>
  //         <div style='margin-left:5px;margin-top:5px'>
  //         ?
  //         </div>
  //         </div>
  //         </div>`,
  //         color: "rgb(28, 192, 217)",
  // 			},
  // 		],
  // 		question: {
  // 			Write: {
  // 				inputStyle: { width: 70, padding: 20 },
  // 				answers: [],
  // 				initialValue: [],
  // 			},
  // 			Circle: {
  // 				initialWordStyle: {color:'#e6a4bd',  border: '2px solid white', borderRadius: '50%', borderColor: 'transparent', fontWeight: 'bold' },
  // 				// initialWordSt<yle: { fontWeight: 'bold', border: 'none',  borderColor: 'transparent' },
  // 				selectWordStyle: {padding:"10", border: '2px solid', borderColor: 'gray' },
  // 				limitSelect: 1,
  // 				listWords: [
  // 					`A. <br> B. <br> C. <br> D.`,
  // 					`A. <br> B. <br> C. <br> D.`,
  // 					`A. <br> B. <br> C. <br> D.`,

  // 				],
  // 				answers: ['0-8', '1-12', '2-4'],

  // 				initialValue: [],
  // 			},
  // 			Layout: `

  // 			<div style='position:relative;'>
  //           <b>a)</b>&ensp; Số bé nhất trong các số 20 107, 19 482, 15 999, 18 7000 là:
  // 					<div style='display:flex; justify-content:space-around;height:10mm;width: 17cm'>
  // 						<input id='0'  type='Circle'>
  // 					</div>
  // 						<b>b)</b>&ensp; Số nào dưới đây có chữ số hàng trăm là 8
  // 					<div style='display:flex; justify-content:space-around;height:10mm;width: 17cm'>
  // 						<input id='1' type='Circle'>
  // 					</div>
  // 						<b>c)</b>&ensp; Số dân của một phường là 12 967 người. Số dân của phường đó làm tròn đến hàng nghìn là
  // 					<div style='display:flex; justify-content:space-around;height:10mm;width: 17cm'>
  // 						<input id='2' type='Circle'>
  // 					</div>

  // <div style='position:absolute;top:37px;left:65px;'>
  // 						20 107<br><br>
  // 						57 680<br><br>
  // 						12 900<br><br>

  // 					</div>
  // 					<div style='position:absolute;top:37px;left:255px'>
  // 						19 482 <br><br>
  // 						48 954<br><br>
  // 						13 000<br><br>

  // 					</div>
  // 					<div style='position:absolute;top:37px;left:445px'>
  // 						15 999<br><br>
  // 						84 723<br><br>
  // 						12 000<br><br>

  // 					</div>
  //           <div style='position:absolute;top:37px;left:635px'>
  //           18 700<br><br>
  //           39 825<br><br>
  //           12 960<br><br>

  //         </div>
  // 			</div>

  //          `,
  // 		},},

  //   4:{
  //     unit: "Unit Starter",
  //     id: "FP8-WB-demo-2023-US-P7-E4",
  //     audio: "",
  //     video: "",
  //     exerciseKey: "/img/FriendsPlus/Page7/Key/E4answerKey.png",
  //     component: T6v2,
  //     inputSize: 123,
  //     stylesTextInput: {
  //       fontSize: "28px",
  //       textAlign: "center",
  //       // fontWeight:700,
  //     },
  //     maxLength:8,
  //     titleQuestion: [
  //       {

  //         title: `<div style='display:flex'>
  //         <div style="background-color: rgb(61, 184, 187); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px;margin-top:-10px">
  //         4
  //     </div>        <div style='background:rgb(250,235,125);padding:5px 10px;border-radius:10px;text-align: center; '>
  //         <span>Số
  //         </spa
  //         </div>
  //         <div style='margin-left:5px;margin-top:5px'>
  //         ?
  //         </div>
  //         </div>
  //         </div>`,
  //         color: "rgb(28, 192, 217)",
  //       },
  //     ],
  //     isHiddenCheck: true,
  //     questions: [
  //       {
  //         title: `
  //      <div style='display:flex'>
  //      <div>
  //      a)
  //      </div>
  //      <div style='margin-left:10px'>
  //      <div style='position:relative'>
  //      <div>
  //       <img style='width:25cm' src='img/FriendsPlus/Page7/E4/1.jpg' />
  //        </div>
  //      <div style='position:absolute;top:38px;left:360px;'>
  //        <input/>
  //          </div>
  //      <div style='position:absolute;top:38px;left:585px;'>
  //        <input/>
  //          </div>
  //      <div style='position:absolute;top:38px;left:715px;'>
  //        <input/>
  //           </div>
  //      </div>
  //      </div>
  //      </div>

  //      <div style='display:flex;margin-top:30px'>
  //      <div>
  //      b)
  //      </div>
  //      <div style='margin-left:10px'>
  //      <div style='position:relative'>
  //      <div>
  //       <img style='width:25cm' src='img/FriendsPlus/Page7/E4/2.jpg' />
  //        </div>
  //      <div style='position:absolute;top:41px;left:242px;'>
  //        <input/>
  //          </div>
  //      <div style='position:absolute;top:41px;left:470px;'>
  //        <input/>
  //          </div>
  //      <div style='position:absolute;top:41px;left:601px;'>
  //        <input/>
  //           </div>
  //       <div style='position:absolute;top:41px;left:831px;'>
  //       <input/>
  //            </div>
  //      </div>
  //      </div>
  //      </div>

  //        `,
  //         answer: [
  //           "17 598 | 17598",
  //           "17 600 | 17 600 ",
  //           "17 601 | 17 601",
  //           "50 000 | 50000",
  //           "70 000 | 70000",
  //           "80 000 | 80000",
  //           "100 000 | 100000",

  //         ],
  //       },
  //     ],
  //   }
  //   ,
  //   5: {
  //     unit: "Unit Starter",
  //     id: "FP8-WB-demo-2023-US-P7-E5",
  //     video: "",
  //     exerciseKey: "/img/FriendsPlus/Page7/Key/E5answerKey.png",
  //     component: T6v2,
  //     // hideBtnFooter:true,
  //     stylesTextInput: {
  //       background: "transparent",
  //       borderBottom: "1px dotted #ccc",
  //       fontSize: "24px",
  //       textAlign: "center",
  //     },
  //     inputSize: 150,
  //     titleQuestion: [
  //       {
  //         title: `<div style='display:flex'>
  //         <div style="background-color: rgb(61, 184, 187); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px;margin-top:-10px">
  //         5
  //     </div>        <div style='background:rgb(250,235,125);padding:5px 10px;border-radius:10px;text-align: center; '>
  //         <span>Số
  //         </spa
  //         </div>
  //         <div style='margin-left:5px;margin-top:5px'>
  //         ?
  //         </div>
  //         </div>
  //         </div>`,
  //         color: "rgb(28, 192, 217)",
  //       },
  //     ],
  //     questionImage: [],
  //     textareaStyle: { width: 1120 },
  //     isHiddenCheck: true,
  //     questions: [
  //       {
  //         title: `
  //         <table border="1" style="border-collapse: collapse;width:20cm">
  //         <tr style='text-align:center;padding:50px 50px;background:rgb(251,225,190)'>
  //             <th>Số liền trước</th>
  //             <th>Số đã cho</th>
  //             <th>Số liền sau</th>
  //         </tr>
  //         <tr style='text-align:center;padding:50px 50px'>
  //             <td>8 289</td>
  //             <td>8 290</td>
  //             <td>8 291</td>
  //         </tr>
  //         <tr style='text-align:center;padding:50px 50px'>
  //             <td>#</td>
  //             <td>42 135</td>
  //             <td>#</td>
  //         </tr>
  //         <tr style='text-align:center;padding:50px 50px'>
  //         <td>#</td>
  //         <td>80 000</td>
  //         <td>#</td>
  //         </tr>
  //         <tr style='text-align:center;padding:50px 50px'>
  //         <td>#</td>
  //         <td>99 999</td>
  //         <td>#</td>
  //         </tr>

  //     </table>

  //         `,
  //         answer: [
  //           `42 134 | 42134`,`42 136 | 42136`,`79 999 | 79999`,`80 001 | 80001`,`99 998 | 99998`,`100 000 | 10000`
  //         ],
  //       },
  //     ],
  //   },
};

export default json;
